var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "On Light BG / Delete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4363"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.7796 5.95087V13.7418C13.7796 15.0487 12.7108 16.1096 11.3942 16.1096H6.6158C5.29922 16.1096 4.23047 15.0487 4.23047 13.7418V5.95087",
    stroke: "#003B4D",
    strokeOpacity: 0.6,
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.13477 4.25497H15.8666M6.61532 4.25497C6.61532 2.94806 7.68407 1.88715 9.00065 1.88715C10.3172 1.88715 11.386 2.94806 11.386 4.25497",
    stroke: "#003B4D",
    strokeOpacity: 0.6,
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.40625 8.99823L10.597 12.1579M10.597 8.99823L7.40625 12.1579",
    stroke: "#003B4D",
    strokeOpacity: 0.6,
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDelete);
export default __webpack_public_path__ + "static/media/new_delete.8cf0af8030434d95cd13509dfb8f6c51.svg";
export { ForwardRef as ReactComponent };